// Get the current URL
const currentUrl = window.location.href;
const productMain = document.querySelector('.section-template--19670173647068__main-padding');
const productTitleChildren = document.querySelectorAll('.product__title > *'); // Select all children of .product__title

// Keywords to check and their corresponding gradient colors and text colors
const keywordStyles = {
    strawberry: {
        gradient: 'radial-gradient(circle, #fff 40%, #EF495F 100%)',
        textColor: '#EF495F'
    },
    orange: {
        gradient: 'radial-gradient(circle, #fff 40%, #DE4522 100%)',
        textColor: '#DE4522'
    },
    winter: {
        gradient: 'radial-gradient(circle, #fff 40%, #138145 100%)',
        textColor: '#138145'
    },
    spearmint: {
        gradient: 'radial-gradient(circle, #fff 40%, #009047 100%)',
        textColor: '#009047'
    },
    grape: {
        gradient: 'radial-gradient(circle, #fff 40%, #7757A4 100%)',
        textColor: '#7757A4'
    }
};

// Find the first keyword included in the URL
const keyword = Object.keys(keywordStyles).find((word) => currentUrl.includes(word));

function applyStyles() {
    if (!keyword) {
        console.log('No matching keyword found in the URL.');
        return;
    }

    const { gradient, textColor } = keywordStyles[keyword];

    if (window.innerWidth <= 480) {
        // Apply styles for very small screens
        const backgroundUrl = `
        url('https://cdn.shopify.com/s/files/1/0727/8326/6012/files/product-burst-bg.webp?v=1734633829') no-repeat center 20% / 300% scroll
        `;
    
        // Combine with the existing gradient
        productMain.style.background = `
            ${backgroundUrl},
            ${gradient}
        `;

        // Reset text colors for very small screens
        productTitleChildren.forEach((child) => {
            child.style.color = textColor;
        });

        console.log('Styles applied for screens <= 480px.');
    } else if (window.innerWidth <= 768) {
        // Apply styles for small screens
        const backgroundUrl = `
        url('https://cdn.shopify.com/s/files/1/0727/8326/6012/files/product-burst-bg.webp?v=1734633829') no-repeat center/200% scroll
        `;
    
        // Combine with the existing gradient
        productMain.style.background = `
            ${backgroundUrl},
            ${gradient}
        `;

        // Reset text colors for small screens
        productTitleChildren.forEach((child) => {
            child.style.color = textColor;
        });

        console.log('Styles applied for screens <= 768px.');
    } else {
        // Apply styles for larger screens
        productMain.style.background = `
            url('https://cdn.shopify.com/s/files/1/0727/8326/6012/files/product-burst-bg.webp?v=1734633829') no-repeat center/cover fixed,
            ${gradient}
        `;
        productMain.style.backgroundAttachment = 'fixed';
        productMain.style.backgroundSize = '90%, cover';

        // Change the color of .product__title > * elements
        productTitleChildren.forEach((child) => {
            child.style.color = textColor;
        });

        console.log('Desktop styles applied.');
    }
}

// Initial application of styles
applyStyles();

// Add resize event listener to dynamically adjust styles
window.addEventListener('resize', applyStyles);


// // Get the current URL
// const currentUrl = window.location.href;
// const productMain = document.querySelector('.section-template--18784810533084__main-padding');
// const productTitleChildren = document.querySelectorAll('.product__title > *'); // Select all children of .product__title

// // Keywords to check and their corresponding gradient colors and text colors
// const keywordStyles = {
//     strawberry: {
//         gradient: 'radial-gradient(circle, #fff 40%, #EF495F 100%)',
//         textColor: '#EF495F'
//     },
//     orange: {
//         gradient: 'radial-gradient(circle, #fff 40%, #DE4522 100%)',
//         textColor: '#DE4522'
//     },
//     winter: {
//         gradient: 'radial-gradient(circle, #fff 40%, #138145 100%)',
//         textColor: '#138145'
//     },
//     spearmint: {
//         gradient: 'radial-gradient(circle, #fff 40%, #009047 100%)',
//         textColor: '#009047'
//     },
//     grape: {
//         gradient: 'radial-gradient(circle, #fff 40%, #7757A4 100%)',
//         textColor: '#7757A4'
//     }
// };

// // Find the first keyword included in the URL
// const keyword = Object.keys(keywordStyles).find((word) => currentUrl.includes(word));

// // Apply the background and text color if a keyword is found
// if (keyword) {
//     const { gradient, textColor } = keywordStyles[keyword];

//     // Apply the background to the main container
//     productMain.style.background = `
//         url('https://cdn.shopify.com/s/files/1/0727/8326/6012/files/nicci-product-bg-2.webp?v=1732301290') no-repeat center/cover fixed,
//         ${gradient}
//     `;

//     // Change the color of .product__title > * elements
//     productTitleChildren.forEach((child) => {
//         child.style.color = textColor;
//     });

//     console.log(`${keyword.charAt(0).toUpperCase() + keyword.slice(1)} is included in the URL. Fixed background and text color applied.`);
// } else {
//     console.log('No matching keyword found in the URL.');
// }
